import Loader from "../../components/Loader";
import {useQuery} from "@tanstack/react-query";
import Customer from "./Customer";
import AddCustomerButton from "./AddCustomerButton";
import {useContext, useEffect, useState} from "react";
import Paginator from "../../components/Paginator";
import {
    Col ,
    Form ,
    FormFeedback ,
    Row ,
    Input ,
    Label ,
    Button ,
    AccordionItem ,
    AccordionBody , AccordionHeader , UncontrolledAccordion
} from "reactstrap";
import AuthContext from "../../context/AuthContext";
import handleUnauthorized401QueryError from "../../utils/handleUnauthorized401QueryError";
import {getCustomers} from "../../api/api";
import {toast} from "react-toastify";
import RecordsNotFound from "../../components/RecordsNotFound";


function CustomerPage() {
    const {refreshToken, user} = useContext(AuthContext)
    const [page, setPage] = useState(1);
    const [customerId, setCustomerId] = useState("");
    const [customerName, setCustomerName] = useState("");
    const [customerEmail, setCustomerEmail] = useState("");
    const [customerPhone, setCustomerPhone] = useState("");
    const [customerIsVIP, setCustomerIsVIP] = useState("");
    const [customerCreditLimit, setCustomerCreditLimit] = useState("");
    const [customerAmountDue, setCustomerAmountDue] = useState("");
    const [customerDueDate, setCustomerDueDate] = useState("");
    const [customerCreatedDate, setCustomerCreatedDate] = useState("");
    const [customerUpdatedDate, setCustomerUpdatedDate] = useState("");

    // const [ openAdvancedSearch , setOpenAdvancedSearch ] = useState ( false );
    const [ isAdvancedSearchDisabled , setIsAdvancedSearchDisabled ] = useState ( false );

    // const toggleAdvancedSearch = () =>
    //     setOpenAdvancedSearch ( ( prevState ) => ! prevState );

    const [queryKey, setQueryKey] = useState(['customers', page])

    useEffect(() => {
        setQueryKey(['customers', page])
    }, [page]);

    useEffect(() => {
        if(customerId === '' && customerName === '' && customerEmail === '' && customerPhone === '' &&
           customerIsVIP === '' && customerCreditLimit === '' && customerAmountDue === '' && customerDueDate === '' &&
           customerCreatedDate === '' && customerUpdatedDate === ''){
            clearSearchCustomer()
        }
    }, [customerId, customerName, customerEmail, customerPhone, customerIsVIP,
        customerCreditLimit, customerAmountDue, customerDueDate, customerCreatedDate, customerUpdatedDate]);


    const { status, data, error, isFetching, refetch } = useQuery({
        queryKey: queryKey,
        queryFn: () => getCustomers(page, customerId, customerName, customerEmail, customerPhone, customerIsVIP,
            customerCreditLimit, customerAmountDue, customerDueDate, customerCreatedDate, customerUpdatedDate),
        keepPreviousData : true,
        retry: false,
        refetchOnWindowFocus: false,
        onError: (err => {
            handleUnauthorized401QueryError(err, refreshToken, refetch)
            if(err.response.status !== 401){
                toast.error(`An error occurred! ${err?.response?.data?.detail}`)
            }
        })
        })

    const shouldShowInitialLoader = status === 'loading' && !data;
    const shouldShowCustomerTable = status === 'success' || Boolean(data) || error?.response?.status === 401;

    const searchCustomer = (e) =>{
        e?.preventDefault()
        setPage(1)
        setQueryKey( ['customers', page, customerId, customerName, customerEmail, customerPhone, customerIsVIP,
            customerCreditLimit, customerAmountDue, customerDueDate, customerCreatedDate, customerUpdatedDate])
    }

    const clearSearchCustomer = (e) =>{
        e?.preventDefault()
        setCustomerId('')
        setCustomerName('')
        setCustomerEmail('')
        setCustomerPhone('')
        setCustomerIsVIP('')
        setCustomerCreditLimit('')
        setCustomerAmountDue('')
        setCustomerDueDate('')
        setCustomerCreatedDate('')
        setCustomerUpdatedDate('')
        setQueryKey( ['customers', 1])
        // setPage(1)
    }

    return (
        <>
            <UncontrolledAccordion defaultOpen="" flush={true}>
                <AccordionItem>
                    <AccordionHeader targetId="1">
                        <span><i className="mdi mdi-filter"/></span>
                    </AccordionHeader>
                    <AccordionBody accordionId="1">
                    <div className="card-box">
                     <div className="row">
                      <div className="col-sm-12">

                        <Form onSubmit={searchCustomer}>
                            <Row className="form-row align-items-center">
                                <Col>
                                    <Label
                                        className="visually-hidden"
                                        for="name"
                                    >
                                        Name
                                    </Label>
                                    <Input
                                        id="customer-name"
                                        name="customer-name"
                                        type="text"
                                        className="form-control mb-2"
                                        onChange={(e) =>
                                            setCustomerName(
                                                e.target.value
                                            )
                                        }
                                        value={customerName}
                                        invalid={
                                            error && error.response.data.name
                                        }
                                    />
                                    <FormFeedback invalid>
                                        {error && error.response.data.name}
                                    </FormFeedback>
                                </Col>
                                <Col>
                                    <Label
                                        className="visually-hidden"
                                        for="customer-email"
                                    >
                                        Email
                                    </Label>
                                    <Input
                                        id="customer-email"
                                        name="customer-email"
                                        type="text"
                                        className="form-control mb-2"
                                        onChange={(e) =>
                                            setCustomerEmail(
                                                e.target.value
                                            )
                                        }
                                        value={customerEmail}
                                        invalid={
                                            error && error.response.data.email
                                        }
                                    />
                                    <FormFeedback invalid>
                                        {error && error.response.data.email}
                                    </FormFeedback>
                                </Col>
                                <Col>
                                    <Label
                                        className="visually-hidden"
                                        for="customer-phone"
                                    >
                                        Phone
                                    </Label>
                                    <Input
                                        id="customer-phone"
                                        name="customer-phone"
                                        type="text"
                                        className="form-control mb-2"
                                        onChange={(e) =>
                                            setCustomerPhone(
                                                e.target.value
                                            )
                                        }
                                        value={customerPhone}
                                        invalid={
                                            error && error.response.data.phone
                                        }
                                    />
                                    <FormFeedback invalid>
                                        {error && error.response.data.phone}
                                    </FormFeedback>
                                </Col>
                                {/*<Col>*/}
                                {/*    <Label*/}
                                {/*        className="visually-hidden"*/}
                                {/*        for="customer-is-vip"*/}
                                {/*    >*/}
                                {/*        VIP*/}
                                {/*    </Label>*/}
                                {/*    <Input*/}
                                {/*        type="select"*/}
                                {/*        id="customer-is-vip"*/}
                                {/*        className="form-control mb-2"*/}
                                {/*        value={customerIsVIP}*/}
                                {/*        onChange={(e) =>*/}
                                {/*            setCustomerIsVIP(*/}
                                {/*                e.target.value*/}
                                {/*            )*/}
                                {/*        }*/}
                                {/*    >*/}
                                {/*        <option value="">--</option>*/}
                                {/*        <option value={true}>*/}
                                {/*            Yes*/}
                                {/*        </option>*/}
                                {/*        <option value={false}>*/}
                                {/*            No*/}
                                {/*        </option>*/}
                                {/*    </Input>*/}
                                {/*    /!*<FormFeedback invalid>*!/*/}
                                {/*    /!*    {error && error.response.data.description}*!/*/}
                                {/*    /!*</FormFeedback>*!/*/}
                                {/*</Col>*/}
                                <Col>
                                    <Label
                                        className="visually-hidden"
                                        for="customer-date-created"
                                    >
                                        Date Created
                                    </Label>
                                    <Input
                                        id="customer-date-created"
                                        name="customer-date-created"
                                        type="date"
                                        className="form-control mb-2"
                                        onChange={(e) =>
                                            setCustomerCreatedDate(
                                                e.target.value
                                            )
                                        }
                                        value={customerCreatedDate}
                                        invalid={
                                            error && error.response.data.created
                                        }
                                    />
                                    <FormFeedback invalid>
                                        {error && error.response.data.created}
                                    </FormFeedback>
                                </Col>

                            </Row>
                            {/*{ ! isAdvancedSearchDisabled && (*/}
                            {/*    <>*/}
                            {/*        <Row className="form-row align-items-center">*/}
                            {/*            <Col>*/}
                            {/*                <div className="form-check">*/}
                            {/*                    <Input*/}
                            {/*                        type="checkbox"*/}
                            {/*                        className="form-check-input"*/}
                            {/*                        id="advanced-search"*/}
                            {/*                        defaultChecked={ openAdvancedSearch }*/}
                            {/*                        disabled={ isAdvancedSearchDisabled }*/}
                            {/*                        onChange={ () =>*/}
                            {/*                            toggleAdvancedSearch ()*/}
                            {/*                        }*/}
                            {/*                    />*/}
                            {/*                    <Label*/}
                            {/*                        check*/}
                            {/*                        className="form-check-label mb-2"*/}
                            {/*                        for="advanced-search"*/}
                            {/*                    >*/}
                            {/*                        Advanced Search*/}
                            {/*                    </Label>*/}
                            {/*                </div>*/}
                            {/*            </Col>*/}
                            {/*        </Row>*/}
                            {/*  /!*      <Accordion open={ openAdvancedSearch }>*!/*/}
                            {/*  /!*          <AccordionItem>*!/*/}
                            {/*  /!*              <AccordionBody accordionId={ true }>*!/*/}
                            {/*  /!*                  <Row className="form-row align-items-center">*!/*/}
                            {/*  /!*                      <Col>*!/*/}
                            {/*  /!*                          <Label*!/*/}
                            {/*  /!*                              className="visually-hidden"*!/*/}
                            {/*  /!*                              for="customer-credit-limit"*!/*/}
                            {/*  /!*                          >*!/*/}
                            {/*  /!*                              Credit Limit*!/*/}
                            {/*  /!*                          </Label>*!/*/}
                            {/*  /!*                          <Input*!/*/}
                            {/*  /!*                              id="customer-credit-limit"*!/*/}
                            {/*  /!*                              name="customer-credit-limit"*!/*/}
                            {/*  /!*                              type="text"*!/*/}
                            {/*  /!*                              className="form-control mb-2"*!/*/}
                            {/*  /!*                              onChange={ ( e ) =>*!/*/}
                            {/*  /!*                                  setCustomerCreditLimit (*!/*/}
                            {/*  /!*                                      e.target.value*!/*/}
                            {/*  /!*                                  )*!/*/}
                            {/*  /!*                              }*!/*/}
                            {/*  /!*                              value={ customerCreditLimit }*!/*/}
                            {/*  /!*                              invalid={*!/*/}
                            {/*  /!*error && error.response.data.credit_limit*!/*/}
                            {/*  /!*                              }*!/*/}
                            {/*  /!*                          />*!/*/}
                            {/*  /!*                          <FormFeedback invalid>*!/*/}
                            {/*  /!*                              { error && error.response.data.credit_limit }*!/*/}
                            {/*  /!*                          </FormFeedback>*!/*/}
                            {/*  /!*                      </Col>*!/*/}
                            {/*  /!*                      <Col>*!/*/}
                            {/*  /!*                          <Label*!/*/}
                            {/*  /!*                              className="visually-hidden"*!/*/}
                            {/*  /!*                              for="amount-due-date"*!/*/}
                            {/*  /!*                          >*!/*/}
                            {/*  /!*                              Amount Due Date*!/*/}
                            {/*  /!*                          </Label>*!/*/}
                            {/*  /!*                          <Input*!/*/}
                            {/*  /!*                              id="amount-due-date"*!/*/}
                            {/*  /!*                              name="amount-due-date"*!/*/}
                            {/*  /!*                              type="date"*!/*/}
                            {/*  /!*                              className="form-control mb-2"*!/*/}
                            {/*  /!*                              onChange={ ( e ) =>*!/*/}
                            {/*  /!*                                  setCustomerAmountDue (*!/*/}
                            {/*  /!*                                      e.target.value*!/*/}
                            {/*  /!*                                  )*!/*/}
                            {/*  /!*                              }*!/*/}
                            {/*  /!*                              value={ customerAmountDue }*!/*/}
                            {/*  /!*                              invalid={*!/*/}
                            {/*  /!*error && error.response.data.amount_due*!/*/}
                            {/*  /!*                              }*!/*/}
                            {/*  /!*                          />*!/*/}
                            {/*  /!*                          <FormFeedback invalid>*!/*/}
                            {/*  /!*                              { error && error.response.data.amount_due }*!/*/}
                            {/*  /!*                          </FormFeedback>*!/*/}
                            {/*  /!*                      </Col>*!/*/}
                            {/*  /!*                      <Col>*!/*/}
                            {/*  /!*                          <Label*!/*/}
                            {/*  /!*                              className="visually-hidden"*!/*/}
                            {/*  /!*                              for="customer-due-date"*!/*/}
                            {/*  /!*                          >*!/*/}
                            {/*  /!*                              Customer Due Date*!/*/}
                            {/*  /!*                          </Label>*!/*/}
                            {/*  /!*                          <Input*!/*/}
                            {/*  /!*                              id="customer-due-date"*!/*/}
                            {/*  /!*                              name="customer-due-date"*!/*/}
                            {/*  /!*                              type="date"*!/*/}
                            {/*  /!*                              className="form-control mb-2"*!/*/}
                            {/*  /!*                              onChange={ ( e ) =>*!/*/}
                            {/*  /!*                                  setCustomerDueDate (*!/*/}
                            {/*  /!*                                      e.target.value*!/*/}
                            {/*  /!*                                  )*!/*/}
                            {/*  /!*                              }*!/*/}
                            {/*  /!*                              value={ customerDueDate }*!/*/}
                            {/*  /!*                              invalid={*!/*/}
                            {/*  /!*error && error.response.data.due_date*!/*/}
                            {/*  /!*                              }*!/*/}
                            {/*  /!*                          />*!/*/}
                            {/*  /!*                          <FormFeedback invalid>*!/*/}
                            {/*  /!*                              { error && error.response.data.due_date }*!/*/}
                            {/*  /!*                          </FormFeedback>*!/*/}
                            {/*  /!*                      </Col>*!/*/}
                            {/*  /!*                      <Col>*!/*/}
                            {/*  /!*                          <Label*!/*/}
                            {/*  /!*                              className="visually-hidden"*!/*/}
                            {/*  /!*                              for="customer-updated-date"*!/*/}
                            {/*  /!*                          >*!/*/}
                            {/*  /!*                              Updated Date*!/*/}
                            {/*  /!*                          </Label>*!/*/}
                            {/*  /!*                          <Input*!/*/}
                            {/*  /!*                              id="customer-updated-date"*!/*/}
                            {/*  /!*                              name="customer-updated-date"*!/*/}
                            {/*  /!*                              type="date"*!/*/}
                            {/*  /!*                              className="form-control mb-2"*!/*/}
                            {/*  /!*                              onChange={ ( e ) =>*!/*/}
                            {/*  /!*                                  setCustomerUpdatedDate (*!/*/}
                            {/*  /!*                                      e.target.value*!/*/}
                            {/*  /!*                                  )*!/*/}
                            {/*  /!*                              }*!/*/}
                            {/*  /!*                              value={ customerUpdatedDate }*!/*/}
                            {/*  /!*                              invalid={*!/*/}
                            {/*  /!*error && error.response.data.updated*!/*/}
                            {/*  /!*                              }*!/*/}
                            {/*  /!*                          />*!/*/}
                            {/*  /!*                          <FormFeedback invalid>*!/*/}
                            {/*  /!*                              { error && error.response.data.updated }*!/*/}
                            {/*  /!*                          </FormFeedback>*!/*/}
                            {/*  /!*                      </Col>*!/*/}
                            {/*  /!*                  </Row>*!/*/}
                            {/*  /!*              </AccordionBody>*!/*/}
                            {/*  /!*          </AccordionItem>*!/*/}
                            {/*  /!*      </Accordion>*!/*/}
                            {/*    </>*/}
                            {/*) }*/}
                            <Row className="form-row align-items-center">
                                { isAdvancedSearchDisabled && (
                                    <Col>
                                        <Button type="submit"
                                                className="btn bx-btn-primary waves-effect waves-light mr-2"
                                                disabled={ ! customerName && ! customerEmail && ! customerPhone && ! customerIsVIP &&
                                                    ! customerCreditLimit && ! customerAmountDue && ! customerDueDate &&
                                                    ! customerCreatedDate && ! customerUpdatedDate }
                                        >
                                            Search
                                        </Button>

                                        <Button type="button"
                                                onClick={ clearSearchCustomer }
                                                className="btn bx-btn-primary waves-effect waves-light"
                                                disabled={ ! customerName && ! customerEmail && ! customerPhone && ! customerIsVIP &&
                                  ! customerCreditLimit && ! customerAmountDue && ! customerDueDate &&
                                  ! customerCreatedDate && ! customerUpdatedDate }
                                        >
                                            Clear
                                        </Button>
                                    </Col>
                                ) }
                                { ! isAdvancedSearchDisabled && (
                                <Col>
                                    <Button type="submit"
                                            className="btn bx-btn-primary waves-effect waves-light mr-2"
                                            disabled={! customerName && ! customerEmail && ! customerPhone && ! customerIsVIP &&
                                  ! customerCreditLimit && ! customerAmountDue && ! customerDueDate &&
                                  ! customerCreatedDate && ! customerUpdatedDate}
                                    >
                                        Search
                                    </Button>

                                    <Button type="button"
                                            onClick={clearSearchCustomer}
                                            className="btn bx-btn-primary waves-effect waves-light"
                                            disabled={! customerName && ! customerEmail && ! customerPhone && ! customerIsVIP &&
                                  ! customerCreditLimit && ! customerAmountDue && ! customerDueDate &&
                                  ! customerCreatedDate && ! customerUpdatedDate}
                                    >
                                        Clear
                                    </Button>
                                </Col>
                                )}
                            </Row>
                        </Form>
                      </div>
                     </div>
                    </div>
                    </AccordionBody>
                </AccordionItem>
            </UncontrolledAccordion>

            <div className="row">
                <div className="col-12">

                    <div className="card-box">
                        <AddCustomerButton/>
                        {shouldShowInitialLoader && (
                            <Loader size={'default'}/>
                        )}
                        {shouldShowCustomerTable && (
                            <>
                                <div className="table-responsive">
                                    <table className="table table-centered mb-0">
                                        <thead className="font-13 bg-light text-muted">
                                        <tr>
                                            <th className="font-weight-medium">Image</th>
                                            <th className="font-weight-medium">Customer Name</th>
                                            <th className="font-weight-medium">Email</th>
                                            <th className="font-weight-medium">Phone</th>
                                            {/*<th className="font-weight-medium">VIP</th>*/}
                                            {/*<th className="font-weight-medium">Credit Limit</th>*/}
                                            <th className="font-weight-medium">Created</th>
                                            <th className="font-weight-medium text-center">Action</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {data?.count > 0? data?.results?.map(customer => (
                                            <Customer key={customer.id} customer={customer}/>
                                        )): <RecordsNotFound/>}
                                        </tbody>
                                    </table>
                                </div>
                                {status === 'success' && (
                                    <Paginator data={data} page={page} setPage={setPage} last={data?.last_page} loading={isFetching}/>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}

export default CustomerPage;
